import "./tournamentHostBanner.css";
import type { TournamentHostBanner } from "./tournamentHostBanners";

export default function TournamentHostBanner({
  hostName,
  hostUrl,
  hostLogo,
  copySuffix,
  ctaLabel,
}: TournamentHostBanner) {
  return (
    <>
      <div className="bass-component__latest-coverage-feed-heading">
        <h3>Host Sponsor</h3>
      </div>
      <section className="thb-banner" aria-label="Tournament host">
        <img
          className="thb-logo"
          src={hostLogo}
          alt={hostName}
          loading="lazy"
        />
        <p className="thb-copy">
          Thank you to <strong>{hostName}</strong> {copySuffix}
        </p>
        <a
          className="thb-cta"
          href={hostUrl}
          target="_blank"
          rel="noopener noreferrer sponsored"
        >
          {ctaLabel}
        </a>
      </section>
    </>
  );
}
